module.exports = __webpack_public_path__ + "img/WechatIMG3111.7271af9d.png";